// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"551":"4008b8b7","773":"49ab8f79"}[chunkId] + ".chunk.css";
};